// First-visit disclaimer: not medical advice, affiliate disclosure.
// Stores acknowledgment in localStorage so returning users aren't pestered.

const KEY = 'mystack:disclaimer-ack:v1';

export function maybeShowDisclaimer() {
  if (localStorage.getItem(KEY)) return;
  const back = document.createElement('div');
  back.className = 'modal-back';
  back.innerHTML = `
    <div class="modal-box">
      <h2>Welcome to MyStack 👋</h2>
      <p><strong>This is a personal tracking and reference tool — not medical advice.</strong></p>
      <p>You'll find paraphrased summaries of public research with citations to the original sources. Anything you read here is general education, not a recommendation for your specific health, medications, or condition. Talk to a clinician before changing what you take.</p>
      <p>Some buy-buttons link to vendor sites and may pay MyStack a small commission. The app stays free; merchants pay us a cut. Your tracking data stays yours and isn't sold.</p>
      <p class="small">By continuing you acknowledge you understand this is not medical advice and that the platform may earn affiliate revenue from outbound vendor links.</p>
      <div style="display:flex;gap:10px;justify-content:flex-end;margin-top:14px;">
        <button id="disclaimer-ack" class="btn btn-primary">I understand — let me in</button>
      </div>
    </div>
  `;
  document.body.appendChild(back);
  document.getElementById('disclaimer-ack')?.addEventListener('click', () => {
    localStorage.setItem(KEY, String(Date.now()));
    back.remove();
  });
}
